const main = () => {
    if (document.querySelector('.c-others-search-condition') === null) return;
    const targetObj = document.querySelector('.c-others-search-condition');
    const mainObj = document.querySelector('main');

    const headerObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // 領域内に入ったときの処理
                delete targetObj.dataset.fixed;
                mainObj.style.paddingTop = 0;
                targetObj.style.top = 0;
            } else {
                // 領域外に出たときの処理
                targetObj.dataset.fixed = '';
                mainObj.style.paddingTop = targetObj.clientHeight + 'px';
                targetObj.style.top = targetObj.clientHeight * -1 + 'px';
            }
        })
    });

    headerObserver.observe(document.querySelector('main > header'));

    let setPosition = 0;
    let scrollDirection = null;
    window.addEventListener('scroll', function () {
        if (setPosition < document.documentElement.scrollTop && scrollDirection !== 'down') {
            scrollDirection = 'down';
            delete targetObj.dataset.show;
        } else if (setPosition > document.documentElement.scrollTop && scrollDirection !== 'up') {
            scrollDirection = 'up';
            targetObj.dataset.show = '';
        }
        setPosition = document.documentElement.scrollTop;
    });

    if (document.querySelector('[data-type-edit-button]')) {
        document.querySelector('[data-type-edit-button]').addEventListener('click', () => {
            document.querySelector('.c-others-search-condition-type-edit-modal').dataset.open = '';
        });
    }

    if (document.querySelector('.c-others-search-condition-type-edit-modal .c-buttons-close')) {
        document.querySelector('.c-others-search-condition-type-edit-modal .c-buttons-close').addEventListener('click', () => {
            delete document.querySelector('.c-others-search-condition-type-edit-modal').dataset.open;
        });
    }

    targetObj.querySelectorAll('.c-others-search-condition__button[data-has-submenu]').forEach(button => {
        button.addEventListener('click', () => {
            button.toggleAttribute('data-is-open');
        });
    });
}

export default main;
